/**
 * Image-based Mega Menu Carousel
 * Handles horizontal scrolling navigation for image grid mega menu
 */

class MegaMenuImageCarousel extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector('.mega-menu-image__track');
    this.prevBtn = this.querySelector('.mega-menu-image__nav-btn--prev');
    this.nextBtn = this.querySelector('.mega-menu-image__nav-btn--next');
    this.cards = Array.from(this.querySelectorAll('.mega-menu-image__card'));

    this.currentIndex = 0;
    this.cardsVisible = this.getVisibleCards();

    this.init();
  }

  init() {
    if (!this.track || this.cards.length === 0) return;

    // Bind button events
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prev());
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.next());
    }

    // Update on resize
    window.addEventListener('resize', () => {
      this.cardsVisible = this.getVisibleCards();
      this.updatePosition();
      this.updateButtons();
    });

    // Set initial position
    this.updatePosition();

    // Initial button state
    this.updateButtons();
  }


  getVisibleCards() {
    const containerWidth = this.offsetWidth;
    const cardWidth = this.cards[0]?.offsetWidth || 0;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 12;

    if (cardWidth === 0) return 4; // Default fallback

    return Math.floor(containerWidth / (cardWidth + gap));
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex -= 1; // Flyt kun ét kort tilbage
      this.updatePosition();
    }
  }

  next() {
    const maxIndex = this.cards.length - this.cardsVisible;
    if (this.currentIndex < maxIndex) {
      this.currentIndex += 1; // Flyt kun ét kort frem
      this.updatePosition();
    }
  }

  updatePosition() {
    if (!this.track || this.cards.length === 0) return;

    const cardWidth = this.cards[0].offsetWidth;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 12;
    const scrollOffset = this.currentIndex * (cardWidth + gap);

    // Simple scroll without extra offset - padding is handled by CSS
    const translateX = -scrollOffset;

    this.track.style.transform = `translate3d(${translateX}px, 0, 0)`;
    this.updateButtons();
  }

  updateButtons() {
    if (!this.prevBtn || !this.nextBtn) return;

    const maxIndex = this.cards.length - this.cardsVisible;

    // Update prev button state
    this.prevBtn.disabled = this.currentIndex === 0;

    // Update next button state
    this.nextBtn.disabled = this.currentIndex >= maxIndex;
  }
}

// Register custom element
if ('customElements' in window) {
  customElements.define('mega-menu-image-carousel', MegaMenuImageCarousel);
}
